import { useEffect } from 'react';
import './Reports.scss';
import { useDispatch } from "react-redux";
import { Typography, Collapse, Image } from 'antd';
import ReportsCollapseContent from './ReportsCollapseContent';
import JvReports from './JvReports';
import ArrowDownIcon from "../../assets/icons/arrow-down-icon.svg"
import { getReportDropdowns } from '../../redux/slices/ReportsSlice';

const { Title } = Typography;

const Reports = () => {
  const dispatch = useDispatch();

  const panelStyle = {
    marginBottom: 10,
    border: "none",
  };

  useEffect(() => {
    dispatch(getReportDropdowns());
  }, [dispatch]);

  const collapseItems = (panelStyle) => [
    {
      key: "1",
      label: "Deal wise status document",
      children: <ReportsCollapseContent type="1" title="Deal wise status document" />,
      style: panelStyle,
    },
    {
      key: "2",
      label: "Deal wise Settlement",
      children: <ReportsCollapseContent type="2" title="Deal wise Settlement" />,
      style: panelStyle,
    },
    {
      key: "3",
      label: "Investor Ledger",
      children: <ReportsCollapseContent type="3" title="Investor Ledger" />,
      style: panelStyle,
    },
    {
      key: "4",
      label: "Business Ledger",
      children: <ReportsCollapseContent type="4" title="Business Ledger" />,
      style: panelStyle,
    },
    {
      key: "5",
      label: "Deal wise Profitability",
      children: <ReportsCollapseContent type="5" title="Deal wise Profitability" />,
      style: panelStyle,
    },
  ];

  return (
    <div className='reports-container'>
      <Title level={4}>Download Reports</Title>
      <div className='reports-details-container'>
        <Collapse
          bordered={false}
          items={collapseItems(panelStyle)}
          expandIconPosition="end"
          expandIcon={({ isActive }) => (
            <Image
              src={ArrowDownIcon}
              alt='Arrow'
              preview={false}
              style={{
                transform: isActive ? 'rotate(180deg)' : 'rotate(0deg)',
                transition: 'transform 0.3s ease'
              }}
            />
          )}
          style={{ background: "#ffffff", width: "100%" }}
        />
      </div>
      <JvReports />
    </div>
  );
}

export default Reports;
